import React, { Component } from "react"
import styled from "styled-components"
import { inject, observer } from "mobx-react"

import withTranslations from "~/components/_hocs/withTranslations"
import Spacer from "~/components/Spacer"
import State from "../Dropdown/State"
import Tooltip from "~/components/Tooltip"
import InputTitle from "./InputTitle"

const InputItemWrapper = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  font-size: 0.9375rem;
  max-width: 364px;
  width: 100%;
`

@inject(all => ({
  validateDisplayMessage:
    all.store.parkingFlow.searchCriteria.validateDisplayMessage,
  setPlateState: all.store.parkingFlow.searchCriteria.setPlateState,
  plateState: all.store.parkingFlow.searchCriteria.plateState
}))
@observer
class PlateState extends Component {
  render() {
    return (
      <InputItemWrapper>
        <InputTitle>
          {this.props.translate('label')}
          <Tooltip
            message={this.props.translate('tooltip')}
            icon="question"
            size={21}
          />
        </InputTitle>
        <Spacer desktop={16} mobile={16} />
        <State
          noIcon
          autoFocus={false}
          selectedState={this.props.plateState}
          onChange={change => {
            this.props.setPlateState(change.value)
          }}
        />
      </InputItemWrapper>
    )
  }
}

export default withTranslations(PlateState, 'form.parking.plateState')
